import Form from "../CustomForm";
import useForm from "src/hooks/use-form";
import { useAlertContext } from "src/hooks/use-alert";
import CompanyValidator from "src/validators/company-validator.ts";
import { useNavigate } from "react-router-dom";
import { CreateCompany,UpdateContract,getAllCompanies } from "src/apis/contract";
import { useEffect } from "react";
import { useState } from "react";
import { getAllAssets } from "src/apis/complex";
import { ContractTypes } from "src/util/utility_enums";
const validator = new CompanyValidator();
// For successful validation, isTouched has to be true and has error has to be false for each field
// 


const assetsList=[];
const sensorsList=[]
const companiesList=[];

// To create a form, Create this object with eack key as the field of the form to create
var properties = {

  
  
  name: {
    value: "",
    type: "text",
    isTouched: false,
    hasError: false,
  },
  phoneNumber: {
    value: "",
    type: "text",
    isTouched: false,
    isPhone: true,
    hasError: false,
  },
  cellNumber: {
    value: "",
    type: "text",
    isTouched: false,
    isPhone: true,
    hasError: false,
  },
  address: {
    value: "",
    type: "text",
    isTouched: false,
    hasError: false,
  },
  email: {
    value: "",
    type: "text",
    isTouched: false,
    hasError: false,
  },
  taxNumber: {
    value: "",
    type: "text",
    isTouched: false,
    hasError: false,
  },
  vatNumber: {
    value: "",
    type: "text",
    isTouched: false,
    hasError: false,
  },
 

};

export default function CompanyForm({ props }) { //props contain data regarding asset to from parent component
  const navigate = useNavigate();
  const alert = useAlertContext();
  const [items, SetItems]=useState("");

 


  const { inputs, errorMessages, isValid, hasError, submitValidationHandler } =
    useForm(validator, properties);

   
  const handleSubmit = async (event) => {
    event.preventDefault();
    submitValidationHandler(event);
    if (isValid && !hasError) {
      let data = {}; //data to send to backend

     
      for (const input in inputs) {
        if(input !== 'asset') {
          data[input] = inputs[input].value;
        }
        else {
          data[input] = { id: parseInt(inputs[input].value) }
      }
      }
      var response;
      var message;
      console.log(data);
      

      //APIS CALLING
      if (!props.contractData) {
        response = await CreateCompany(data);
        message = "Company created successfully!";
      } else {
        // data.id = props.asset.id;
       // data.asset = { id: props.assetData.id };
        response = await UpdateContract(data);
        message = "Contract updated successfully!";
      }

      console.log("submit:" + JSON.stringify(response));
      if (response.success) {
        // success alert
        alert.setSuccess((prev) => [...prev,{
          status: true,
          message: message,
          index:prev.length
        }]);
        if (isNaN(props.steps)) {
          return props.custom ? props.onSubmit(false, true) : navigate("..");
        }
        return props.handleNext({
          id: response.object.id,
          name: data.name,
        });
      } else {
        alert.setError((prev) => [...prev,{ status: true, messages: response.errors,index:prev.length }]);
        return props.custom ? props.onSubmit(false) : null;
      }
    }
    return props.custom ? props.onSubmit(false) : null;
  };

  return (
    <>
      <Form
        title={"Creat Company"}
        inputs={inputs}
        errorMessages={errorMessages}
        isValid={isValid}
        custom={props.custom ?? false}
        hasError={hasError}
        activeStep={props.activeStep}
        steps={props.steps}
        onSubmit={handleSubmit}
        externalSubmit={props.externalSubmit ?? null}
        handleBack={props.handleBack ?? null}
      />
    </>
  );
}
